import $ from 'jquery';

class RiversDropdown {
  constructor() {
    this.riversDropdpwnBlock = $('.js-block-rivers-dropdown');

    if (!this.riversDropdpwnBlock.length) {
      return;
    }

    this.selectionRedirect();
  }

  selectionRedirect() {
    this.riversDropdpwnBlock.each((index, element) => {
      const block = $(element);
      const dropdown = block.find('.js-rivers-dropdown');

      dropdown.on('change', e => {
        const selection = e.target.value.trim();
        if (selection !== '') {
          window.history.pushState(null, document.title, window.location.href);
          window.location.replace(selection);
        }
      });
    });
  }
}

export default new RiversDropdown();



// WEBPACK FOOTER //
// ./src/scripts/modules/rivers-dropdown.js